import { Settings } from "luxon";

// luxonのタイムゾーンを設定
Settings.defaultZone = "Asia/Tokyo";
Settings.defaultLocale = "ja";
